import { useCallback } from 'react';
import {
  useBrandPanelQuery,
  useBrandCampaignsQuery,
  useBrandCatalogQuery,
} from '../../queries/brandMetrics';
import brandMetricsApi from '../../api/brandMetrics';
import BrandView from './BrandView';

const keepPrevious = { placeholderData: (prev) => prev };

/**
 * Panel admin de una marca: fetch del período + comparación + campañas, y
 * delega el layout a BrandView. `brand` (de la lista de marcas) da la identidad
 * del header antes de que cargue el panel; después la refresca el payload.
 */
export default function BrandPanel({ brand, dateControls, compareStart, compareEnd, onBack, brandSwitcher }) {
  const brandId = brand.id;
  const { start, end } = dateControls;

  const panelQuery = useBrandPanelQuery(brandId, start, end, keepPrevious);
  const compareQuery = useBrandPanelQuery(brandId, compareStart, compareEnd, {
    enabled: Boolean(
      brandId && compareStart && compareEnd && panelQuery.data?.brand?.vertical === 'ecommerce'
    ),
  });
  const campaigns = useBrandCampaignsQuery(brandId, start, end, keepPrevious);
  const catalog = useBrandCatalogQuery(brandId, start, end, {
    enabled: Boolean(
      brandId && start && end && panelQuery.data?.brand?.vertical === 'ecommerce'
    ),
    ...keepPrevious,
  });

  const previewFetcher = useCallback(
    (creativeId) => brandMetricsApi.getBrandCreativePreview(brandId, creativeId),
    [brandId]
  );

  return (
    <BrandView
      brand={panelQuery.data?.brand ?? brand}
      panel={{
        data: panelQuery.data,
        isLoading: panelQuery.isLoading,
        isError: panelQuery.isError,
        previousSummary: compareQuery.data?.summary,
      }}
      campaigns={campaigns}
      catalog={catalog}
      dateControls={dateControls}
      onBack={onBack}
      brandSwitcher={brandSwitcher}
      previewFetcher={previewFetcher}
    />
  );
}
